module.exports = __webpack_public_path__ + "img/succespurchase.3c287983.png";